import { Authsignal } from "@authsignal/browser"

import { AppSettings } from "@/settings"

export const getAuthsignalClient = () => {
  return new Authsignal(AppSettings.getAuthsignalEnv())
}
